export const ConferenceProviderType = {
    BuiltIn: "Built-In",
    GoogleMeet: "Google Meet",
    MicrosoftTeams: "Microsoft Teams",
    Zoom: "Zoom",
    Other: "Other",
};
